// extracted by mini-css-extract-plugin
module.exports =  {"thankYouMessage":"TNxMXT","errorMessage":"mqgIGr","errorIcon":"ypaAGp"};